import Vue from 'vue'

// axios
import axios from 'axios'
import rutasjson from "@/assets/utils/rutas.json"

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: rutasjson.axios,
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})

Vue.prototype.$http = axiosIns

export default axiosIns
